export function toString(value) {
    if (typeof value === 'string') {
        return value
    }
    if (value === null || value === undefined) {
        return ''
    }
    if (typeof value === 'object') {
        if (Array.isArray(value)) {
            return JSON.stringify(value)
        } else {
            let str = value.toString()
            if (str === '[object Object]') {
                str = JSON.stringify(value)
            }
            return str
        }
    }
    return String(value)
}
